module.exports = __webpack_public_path__ + "img/block-fixed.fafc177a.jpg";